// Ссылка на в тг, honey pot для новых клиентов
export const botLink = 'https://t.me/pavelveter'
